import SelectedKDSPage from 'pages/kds/selectedkds';
import React from 'react';

export default function KDSSelected() {
  return <SelectedKDSPage />;
}
